import tweakwisePriceUpdater from '@client/utils/tweakwisePriceUpdater'

const reloadTweakwise = () => {
  const tweakwiseInstance = window['twn-starter-instance'];

  if (tweakwiseInstance) {
    tweakwiseInstance.refresh();
  }

  // Initialize price updater
  tweakwisePriceUpdater.init()

  // Update prices after Tweakwise refresh if dates are set
  setTimeout(() => {
    tweakwisePriceUpdater.updatePricesIfDatesSet()
  }, 500)
}

// Track current pathname to detect cross-page navigation
let lastPathname = window.location.pathname;

$(document).on('turbolinks:load', () => {
  // Update tracked pathname on page load
  lastPathname = window.location.pathname;
  reloadTweakwise()
})

window.addEventListener('popstate', () => {
  const currentPathname = window.location.pathname;

  // If pathname changed, we need a full page navigation (not just Tweakwise reload)
  if (lastPathname !== currentPathname) {
    lastPathname = currentPathname;
    // Use full page reload to ensure React components mount correctly
    window.location.reload();
  } else {
    // Same page, just reload Tweakwise (e.g., filter/search changes)
    reloadTweakwise();
  }
})

// Clean up on page unload
$(document).on('turbolinks:before-cache', () => {
  tweakwisePriceUpdater.destroy()
})
